export default "__VITE_ASSET__DSq_CJc___"